import { Component, OnInit } from '@angular/core';
import { MetaProvider } from '../../services/meta.provider';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-signinthankyou',
  templateUrl: 'signinthankyou.html',
  styleUrls: ['signinthankyou.scss']
})
export class SignInThankYouPage implements OnInit {
  public page2: string;
  public email: string;

  constructor(private actRoute: ActivatedRoute, private router: Router, private meta: MetaProvider) { }

  ngOnInit(): void {
    if (this.actRoute.snapshot.queryParams.page2) {
      this.page2 = this.actRoute.snapshot.queryParams.page2;
    }
    if (this.actRoute.snapshot.queryParams.email) {
      this.email = this.actRoute.snapshot.queryParams.email;
    }
  }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  public goToProfiles() {
    this.router.navigate(['profiles']);
  }

  // goToHome() {
  //   this.router.navigate(['']);
  // }

  public isLogin() {
    return 'login';
  }
}
